import { Settings } from '@/config'
import { SearchContextManager } from '@giphy/react-components'

export const GyphiProvider = ({ children }) => {
  return (
    <SearchContextManager apiKey={Settings.ApiCredentials.Gyphi.ApiKey}>
      {children}
    </SearchContextManager>
  )
}
